import type { TextFilterValue } from '../state/text';
import { TextFilterStateMap } from '../state/text';
import { extractAttributeCode, prefixAttribute } from './attributeCode';
import { Chunk, HashMap, HashSet, Order, pipe, Schema, String as Str, SchemaGetter } from 'effect';

const hashSetToString = (hashSet: HashSet.HashSet<string>): string =>
  pipe(hashSet, Chunk.fromIterable, Chunk.sort(Order.String), Chunk.join('|'));

const stringToHashSet = (str: string): HashSet.HashSet<string> =>
  pipe(
    str,
    Str.split('|'),
    Chunk.fromIterable,
    Chunk.filter((s) => s.length > 0),
    HashSet.fromIterable
  );

const textFilterStateMapToApiRecord = (
  filterStateMap: TextFilterStateMap
): Record<string, string> =>
  HashMap.reduce(filterStateMap, {} as Record<string, string>, (acc, textValue, attributeCode) => {
    if (HashSet.size(textValue) > 0) {
      acc[prefixAttribute(attributeCode)] = hashSetToString(textValue);
    }
    return acc;
  });

const apiRecordToTextFilterStateMap = (apiRecord: Record<string, string>): TextFilterStateMap => {
  let result = HashMap.empty<string, TextFilterValue>();
  for (const [prefixed, value] of Object.entries(apiRecord)) {
    const code = extractAttributeCode(prefixed);
    const hashSetValue = stringToHashSet(value);
    result = HashMap.set(result, code, hashSetValue);
  }
  return result;
};

export const TextApiQuery = Schema.Record(Schema.String, Schema.String);

export const TextToApi = Schema.toType(TextFilterStateMap).pipe(
  Schema.decodeTo(TextApiQuery, {
    decode: SchemaGetter.transform(textFilterStateMapToApiRecord),
    encode: SchemaGetter.transform(apiRecordToTextFilterStateMap),
  })
);
